export default "__VITE_ASSET__CDbiJyci__"